import * as React from 'react';
import styles from './styles.css';

interface IProps {
  children: React.ReactNode;
}

export const SuburbanBlockHeader: React.FC<IProps> = ({ children }) => {
  return <h1 className={styles['title']}>{children}</h1>;
};
